import { SberFlowInitiator } from '../types/flows';
import { DeepLinkTypes } from '../types/sberId';

export const deepLinkFlowMap = {
  [DeepLinkTypes.authBySberIDWeb]: SberFlowInitiator.ssoWeb,
  [DeepLinkTypes.authBySberIDApp]: SberFlowInitiator.ssoApp
};
